export function WithSmallestProperty<T>(array: T[], property: keyof T): T | null {
  return (array.length && array.reduce(function(prev, curr){
    return prev[property] < curr[property] ? prev : curr;
  })) || null;
}
